import { getOnDetail } from '@/common/converter/utils/get-event-property'

import { restEventCommonParams } from '@/common/converter/const'

/**
 * convert event 'on-detail'
 * on detail 경우 catalog 에서 테스트 필요
 * @param elementList
 * @returns {undefined|{cta: string, add_timestamp: string, method: string, add_common_params: string, bodylist, add_credential: string, type: string, url}}
 */
export const convertEventOnDetail = (elementList = []) => {
  const { type, url, cta, method, bodyList, isRender } =
    getOnDetail(elementList)

  if (!isRender) return undefined

  return {
    type,
    url,
    cta,
    method,
    bodylist: bodyList,
    ...restEventCommonParams,
  }
}
